import { useCallback, useState } from 'react';
import ls from 'local-storage';

export const useScenarioModals = (resetState, setDataFromStorage, setCurrentStep) => {
  const [backConfirmModal, setBackConfirmModal] = useState(null);
  const [showContinueModal, setShowContinueModal] = useState(null);

  const onBack = useCallback((callback = () => { }) => {
    setBackConfirmModal({ action: callback });
  }, []);

  const handleBackConfirm = useCallback(() => {
    backConfirmModal.action();
    setBackConfirmModal(null);
  }, [backConfirmModal]);

  const handleBackCancel = useCallback(() => {
    setBackConfirmModal(null);
  }, []);

  const handleContinueCancel = useCallback(() => {
    resetState();
    setShowContinueModal(null);
  }, [resetState]);

  const handleContinueConfirm = useCallback(() => {
    setDataFromStorage();
    setCurrentStep(ls.get('scenario_wizard_step'));
    setShowContinueModal(null);
  }, [setDataFromStorage, setCurrentStep]);

  const checkForSavedProgress = useCallback(() => {
    const wizardData = ls.get('scenario_wizard_data');
    const wizardStep = ls.get('scenario_wizard_step');
    if (wizardData && wizardStep) {
      setShowContinueModal({ data: wizardData, step: wizardStep });
    }
  }, []);

  return {
    backConfirmModal,
    showContinueModal,
    onBack,
    handleBackConfirm,
    handleBackCancel,
    handleContinueCancel,
    handleContinueConfirm,
    checkForSavedProgress
  };
}; 